import { compose, createStore, applyMiddleware, Middleware } from "redux";
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";

// ONE async side effect library ie. thunk or saga
//import thunk from "redux-thunk";
import createSagaMiddleware from "@redux-saga/core";
import { rootSaga } from "./root-saga";

import { rootReducer } from "./root-reducer";
import { myLoggerMiddleware } from "./middleware/logger";

export type RootState = ReturnType<typeof rootReducer>;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
  }
}

type ExtendedPersistConfig = PersistConfig<RootState> & {
  whitelist: (keyof RootState)[];
};

const persistConfig: ExtendedPersistConfig = {
  // persist the whole thing
  key: "root",
  // where to persist
  storage: storage,
  // whitelist of reducers
  whitelist: ["cart"],
  // blacklist of reducers
  //blacklist: ["user"],
};

const sagaMiddleware = createSagaMiddleware();

// create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// only use logger in development
// using REDUX_THUNK as middleware gives it access to the store's'dispatch and getState
// when invoking the thunk. The middleware itself is responsible for injecting those
// dependencies into the thunk
// using REDUX-SAGA
const middlewares = [
  process.env.NODE_ENV !== "production" && logger,
  sagaMiddleware /*thunk*/,
  // narrow return type to middleware
].filter((middleware): middleware is Middleware => Boolean(middleware));

// enable react dev tools interaction
const composeEnhancer =
  (process.env.NODE_ENV !== "production" &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const composedEnhancers = composeEnhancer(applyMiddleware(...middlewares));

// use the persisted reducer in the store
export const store = createStore(persistedReducer, undefined, composedEnhancers);

// after store has been initiated we can run saga
sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
